// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// import router, {route} from './router'
import router from './router'
import './common/rem.js'

import Vant, { Toast } from 'vant'

import axios from 'axios'
import './common/http.js'

import 'babel-polyfill'
import Es6Promise from 'es6-promise'
import store from './store'
import { isWeixin, isMiniProgamme, miniProgNavigateTo } from './common/util.js'

import md5 from 'js-md5'
//import VConsole from 'vconsole'
//let vConsole = new VConsole()
// console.log(vConsole, 'vConsole')

import { simonConfig } from '../config/index.js'

// 懒加载
import vueLazyload from 'vue-lazyload'
Vue.use(vueLazyload)

// 图片剪切
// import Croppa from 'vue-croppa'
// Vue.use(Croppa)

// 如果其他地方用到视频播放就引入这个video.js
// import VideoPlayer from 'vue-video-player'
// require('video.js/dist/video-js.css')
// require('vue-video-player/src/custom-theme.css')
// Vue.use(VideoPlayer);
console.log('当前环境', process.env.NODE_ENV)
Es6Promise.polyfill()
// 设置请求头
Vue.prototype.$md5 = md5

axios.defaults.headers["x-token"] = localStorage.getItem("token")
const request = axios.create({
  baseURL: simonConfig.baseReq, //开发环境用这个
  // baseURL: '', //测试服、正式环境切换成这个
  timeout: 10000
})

request.interceptors.request.use(config => {
  const token = localStorage.getItem("token")
  if (token) {
    config.headers.common['x-token'] = token
    config.headers['x-token'] = token
  }
  return config
}, error => {
  return Promise.reject(error)
})

request.interceptors.response.use(response => {
  if (response.data.error === 9999) {
    if (localStorage.getItem('token')) {
      Toast('登录失效，请重新登录')
      localStorage.removeItem('token')
      router.push('/SdLogin')
    }
  }
  return response
}, error => {
  return Promise.resolve(error.response)
})
// 字符串两变去空
Vue.prototype.$trimStr = (str) => {
  return str.replace(/(^\s*)|(\s*$)/g, '')
}
// 建立全局长连接
//const webSocket = new WebSocket('wss://test.shendutv.com:9502') // 测试环境

const webSocket = new WebSocket(process.env.NODE_ENV === 'production' ? `wss://${location.hostname}:9502` : 'wss://test.shendutv.com:9502')

webSocket.onopen = function () {
  // webSocket.send(localStorage.getItem('uid')) // 重要!!客户端返回服务器
  if (localStorage.getItem('uid')) {
    let uid = localStorage.getItem('uid')
    let json = `{"uid":${uid}}`
    webSocket.send(json)
  }
}
webSocket.onmessage = function (event) {
  let res = JSON.parse(event.data)
  store.dispatch('setChatText', res)
}

Vue.prototype.$webSocket = webSocket
Vue.prototype.$isWexin = isWeixin
// end
const isLogin = () => {
  return localStorage.getItem('token') ? true : false
}
/**
 * @description: 判断环境
 * @param {boolean} isMinProgamme一个是全局原型 取反时为测试
 * @param {boolean} isMinProgamme一个是用于判断的变量
 * @return: 
 */
isMiniProgamme().then(res => {
  Vue.prototype.isMinProgamme = res // 是否在小程序里面
  const isMinProgamme = res // 是否在小程序里面
  // 路由全局守卫
  router.beforeEach((to, from, next) => {
    getMiniProgramOpenId()
    if (isMinProgamme && !(localStorage.getItem("miniOpenid") || location.href.indexOf('miniOpenid') == -1)) {
      miniProgNavigateTo('/pages/entry/entry')
      //next()
      return
    }
    if (to.path == '/SdSeeDoctor') {
      if (isLogin()) {
        request.defaults.headers.common['x-token'] = localStorage.getItem('token')
      }
      next()
    } else {
      if (!isMinProgamme && (to.path === '/SdInquiry' || to.path === '/SdAskOrder')) {
        // console.log("localStorage.getItem('openid')", localStorage.getItem('openid'))
        // console.log("isWeixin", isWeixin)
        // console.log("isMinProgamme", isMinProgamme)
        // 2019年5月28日21:40:43 这里有个逻辑错误就是openid是在url中获取的判断但是本地有没有
        if (!localStorage.getItem('openid') && isWeixin && !isMinProgamme) {
          // alert('我要去执行getOpenid()了')
          if (isLogin()) {
            request.defaults.headers.common['x-token'] = localStorage.getItem('token')
          }
          getOpenId(to.fullPath, next)
          // console.log(getOpenId(to.fullPath, next))
          return
        }
        if (!isLogin()) {

          next({
            path: '/SdLogin',
            query: { redirect: to.fullPath, loginFrom: from.fullPath }
          })
          return
        }
        else {
          request.defaults.headers.common['x-token'] = localStorage.getItem('token')
          next()
        }
      }
      else if (to.path === '/SdDetailVideo' || to.path === '/SdGroupDetail') {
        if (isLogin()) {
          request.defaults.headers.common['x-token'] = localStorage.getItem('token')
        }
        // 在微信里且没有授权
        if (!localStorage.getItem('openid') && isWeixin && !isMinProgamme) {
          // alert('我要去执行getOpenid()了')
          getOpenId(to.fullPath, next) // 打包到服务器需要打开  获取openid
          //next()
          return
        }
        request.defaults.headers.common['x-token'] = localStorage.getItem('token')
        next()
      }
      else {
        // next()
        // 跳转到这个路由组件时需不需要先登录
        if (to.meta.requireAuth == true) {
          if (!isLogin()) {
            if (to.path === '/SdLogin' || to.path === '/SdRegister') {
              next()
              return
            } else {
              next({
                path: '/SdLogin',
                query: { redirect: to.fullPath, loginFrom: from.fullPath }
              }
              )
              return
            }
          } else {
            request.defaults.headers.common['x-token'] = localStorage.getItem('token')
            next()
            return
          }
        } else {
          request.defaults.headers.common['x-token'] = localStorage.getItem('token')
          next()
          return
        }
        if (to.path === undefined || to.path === '') {
          router.push('/SdSeeDoctor')
          next()
        }
      }
    }
  })
})

const getMiniProgramOpenId = function (query) {
  const arr = location.href.split('miniOpenid=')
  var miniOpenid = null
  if (arr.length) {
    miniOpenid = arr[1]
  }
  //alert(minOpenid)
  if (miniOpenid) {
    localStorage.setItem("miniOpenid", miniOpenid) // 小程序 openId
  }
}
// 获取openid方法
const getOpenId = (val, next) => {
  let http = decodeURIComponent(window.location.href)
  console.log('openid http', http)
  // console.log(!!http.indexOf('openid'), '如果为真的话我就去截取openid哦 false的话说明当前地址没有openid我就要去跳转了吖')
  if (http.indexOf('openid') > -1) {
    let openid = http.split('openid=')[2]
    if (openid) {
      console.log('main.js openid', openid)
      localStorage.setItem('openid', openid)
    }
    next()
  } else {
    let url = val.split('/')[1]
    // window.location.href = `https://test.shendutv.com/wx/tz?url=${url}` // 测试环境
    window.location.href = location.origin + `/wx/tz?url=${encodeURIComponent(url)}` //正式环境
  }
}
Vue.prototype.$isLogin = isLogin
Vue.prototype.$http = request
// isMiniProgamme().then(res=>{
//   Vue.prototype.isMinProgamme = res // 是否在小程序里面
// })

Vue.config.productionTip = false
Vue.prototype.$ObjToFd = (data) => {
  const keys = Object.keys(data)
  if (keys.length > 0) {
    const result = new FormData()
    keys.forEach(key => {
      result.append(key, data[key])
    })
    return result
  }
  return false
}
console.log('Vue.prototype', Vue.prototype)
Vue.use(Vant)
const clickoutsideContext = '@@clickoutsideContext';
Vue.directive("clickoutside", {
  /*
   @param el 指令所绑定的元素
   @param binding {Object}
   @param vnode vue编译生成的虚拟节点
   */
  bind(el, binding, vnode) {
    const documentHandler = function (e) {
      if (!vnode.context || el.contains(e.target)) {
        return false;
      }
      if (binding.expression) {
        vnode.context[el[clickoutsideContext].methodName](e)
      } else {
        el[clickoutsideContext].bindingFn(e);
      }
    }
    el[clickoutsideContext] = {
      documentHandler,
      methodName: binding.expression,
      bindingFn: binding.value
    }
    setTimeout(() => {
      document.addEventListener('touchstart', documentHandler);
    }, 0)
  },
  update(el, binding) {
    el[clickoutsideContext].methodName = binding.expression;
    el[clickoutsideContext].bindingFn = binding.value;
  },
  unbind(el) {
    document.removeEventListener('touchstart', el[clickoutsideContext].documentHandler);
  }
})

// 封装请求url
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js